(function () {
  // LuxCanva: pe mobil, cand clientul schimba Rama (Inramat) sau Dimensiunea,
  // deruleaza inapoi la galeria de poze ca sa vada imaginea actualizata (Nova Variant Images).
  if (window.__lcVariantScroll) return;
  window.__lcVariantScroll = true;

  var MOBILE_MAX = 749;               // acelasi breakpoint ca Nova
  var HEADER_OFFSET = 80;             // spatiu pt header sticky (~61px) + margine
  var lastScroll = 0;                 // debounce: un singur scroll per selectie
  var OPT_RE = /-options-/i;          // numele inputurilor de varianta GemPages

  function isMobile() { return window.innerWidth <= MOBILE_MAX; }

  function galleryEl() {
    return document.querySelector('app-media-gallery') ||
           document.getElementById('app__media__gallery') ||
           document.querySelector('.app-gallery-main');
  }

  // starea curenta a optiunilor: name -> valoarea selectata
  function variantState() {
    var s = {};
    var radios = document.querySelectorAll('input[type=radio][name*="-options-"]:checked, input[type=hidden][name*="-options-"]');
    radios.forEach(function (r) { if (OPT_RE.test(r.name)) s[r.name] = r.value; });
    document.querySelectorAll('select[name*="-options-"]').forEach(function (sel) {
      if (OPT_RE.test(sel.name)) s[sel.name] = sel.value;
    });
    return s;
  }

  function changed(a, b) {
    var keys = {}; Object.keys(a).forEach(function (k) { keys[k] = 1; }); Object.keys(b).forEach(function (k) { keys[k] = 1; });
    for (var k in keys) { if (a[k] !== b[k]) return true; }
    return false;
  }

  function galleryMostlyOut() {
    var g = galleryEl(); if (!g) return false;
    var r = g.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    return visible < r.height * 0.5; // mai putin de jumatate din galerie e vizibila
  }

  function scrollToGallery() {
    var g = galleryEl(); if (!g) return;
    var y = g.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - HEADER_OFFSET;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  var last = variantState();
  // reimprospateaza starea initiala dupa ce GemPages randeaza optiunile
  window.addEventListener('DOMContentLoaded', function () { last = variantState(); });
  window.addEventListener('load', function () { last = variantState(); });
  setTimeout(function () { last = variantState(); }, 1500);

  function check() {
    var now = variantState();
    if (changed(last, now)) {
      last = now;
      var t = Date.now();
      if (isMobile() && galleryMostlyOut() && (t - lastScroll) > 800) {
        lastScroll = t;
        // mic delay ca Nova sa apuce sa schimbe imaginea inainte de scroll
        setTimeout(scrollToGallery, 120);
      }
    }
  }

  // GemPages bifeaza radio-ul programatic (uneori fara event 'change'),
  // deci ascultam si click, si change, si input, si reevaluam starea dupa un tick.
  ['click', 'change', 'input'].forEach(function (type) {
    document.addEventListener(type, function () { setTimeout(check, 250); }, true);
  });
})();
